export enum RequestCorrespondenceSection {
	FollowUp = "FOLLOW_UP",
	Investigation = "INVESTIGATION",
	Prosecution = "PROSECUTION",
	Discipline = "DISCIPLINE",
}
